export default __webpack_public_path__ + "static/media/sunrise-mobile.fe87cd3b.svg";